<!-- 冲减明细 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn" style="margin-bottom: 10px">
            <div class="search-ctn-left">
                <el-button size="small" class="search-btn btn-primary" v-if="permission.unOffsetAccount" @click="unOffsetAccount">{{permission.unOffsetAccount}}</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border="" style="width: 100%; margin-bottom: 0px">
                <el-table-column show-overflow-tooltip width="190px" prop="OrderCode" label="单号"></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="OrderType" label="单据类型">
                    <template slot-scope="scope">
                        <i v-if="scope.row.OrderType == 0" class="c-active">销售收款</i>
                        <i v-else-if="scope.row.OrderType == 1" class="out-active">销售退货</i>
                        <i v-else>建账</i>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="PayTypeName" label="支付方式"></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="TotalAmount" label="应收总额">
                    <template slot-scope="scope">{{ scope.row.OrderType != 1 ? scope.row.TotalAmount : -scope.row.TotalAmount }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip min-width="100px" prop="Remark" label="备注"></el-table-column>
                <el-table-column show-overflow-tooltip width="75px" prop="SName" label="开单人"></el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['RecordId'],
    components: {},
    data() {
        return {
            loading: false,
            tableData: [],
            permission: {},
        };
    },
    mounted() {
        this.permission = this.$util.getPermission('CusReceivable_H');
        this.getDetails();
    },
    methods: {
        cancel() {
            this.$emit('closeDetails');
        },
        getDetails() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement_H/GetCusOffsetDetail',
                    hideLoading: true,
                    data: { RecordId: this.RecordId }
                })
                .then(res => {
                    if (!res.data) return;
                    this.tableData = res.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        unOffsetAccount() {
            let recordId = this.RecordId;
            let that = this;
            this.$util.elConfirm({
                content: '您是否要反冲减该帐？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/RevenueManagement_H/UnOffsetAccounts?recordId=${recordId}`,
                            hideLoading: true
                        })
                        .then(res => {
                            that.$util.successMsg('反冲减成功');
                            that.$emit('closeDetails',true);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
.dialog-content {
    margin: 5px;
}
.btn-ctn {
    text-align: right;
}
.el-row {
    margin-bottom: 0px;
    &:last-child {
        margin-bottom: 0;
    }
}
</style>
